<mat-form-field class="sem-text-box" [class.tags-readonly]="isLocked">
    <mat-chip-grid #chipGrid>
        @for (keyword of keywords; track keyword) {
        <mat-chip-row (removed)="remove(keyword)" [editable]="!isLocked" (edited)="edit(keyword, $event)"
            [aria-description]="'press enter to edit ' + keyword">
            {{keyword}}
            @if (!isLocked) {
            <button matChipRemove [attr.aria-label]="'remove ' + keyword">
                <mat-icon>cancel</mat-icon>
            </button>
            }
        </mat-chip-row>
        }
        <input [placeholder]="isLocked ? '' : translationsService.translate('WebGalis_Tags_Input_New_Tag')"
            [readonly]="isLocked" [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)" class="tag-input" />
    </mat-chip-grid>
</mat-form-field>